<template>
  <ValidationProvider
    :ref="validationProviderRef"
    v-slot="{ errors}"
    :mode="veeValidateInteractionMode"
    :rules="rules"
    :name="label"
    :vid="validationProviderRef"
    :debounce="validationDelay"
  >
    <DecoratedNativeVTextarea
      :id="validationProviderRef"
      :ref="textAreaRef"
      v-model="mutableValue"
      :label="displayedLabel"
      :required="isRequired"
      :counter="counter ? rules.max : null"
      :disabled="disabled"
      :readonly="readonly"
      :errorMessages="errors"
      :dataCy="dataCy"
      :dense="dense"
      :autoGrow="autoGrow"
      :rows="rows"
      v-bind="$attrs"
      v-on="$listeners"
      @input="$emit('input', mutableValue)"
    />
  </validationprovider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import DecoratedNativeVTextarea from '@/components/shared/widgets/forms/VuetifyInputs/decoratedVendorsComponent/DecoratedNativeVTextarea.vue';
import validationProviderHelperMixin from '@/components/shared/widgets/forms/validationHelper/validationProviderHelperMixin';

export default {
    components: {
        ValidationProvider,
        DecoratedNativeVTextarea,
    },
    mixins: [validationProviderHelperMixin],
    props: {
        label: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            default: null,
        },
        rules: {
            type: Object,
            default: () => ({}),
        },
        type: {
            type: String,
            default: 'text',
        },
        extraClass: {
            type: String,
            default: null,
        },
        counter: {
            type: Boolean,
            default: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        dataCy: {
            type: String,
            default: '',
        },
        dense: {
            type: Boolean,
            default: false,
        },
        autoGrow: {
            type: Boolean,
            default: false,
        },
        rows: {
            type: String,
            default: '5',
        },
    },
    data() {
        return {
            mutableValue: this.value,
            textAreaRef: this.$utils.generateRandomString(),
        };
    },
    computed: {
        textArea() {
            return this.$refs[this.textAreaRef] || null;
        },
        displayedLabel() {
            return `${this.label} ${this.isRequired ? '*' : ''}`;
        },
        isRequired() {
            return Object.keys(this.rules).some(rule => (rule === 'required' && this.rules[rule]));
        },
    },
    watch: {
        value() {
            this.mutableValue = this.value;
            if (!!this.mutableValue && this.mutableValue !== '') {
                this.$nextTick(() => {
                    this.validateValidationProvider().then(res => {
                        if (res.valid) this.validateValidationProvider(false);
                    });
                });
            }
        },
    },
    methods: {
        getCursorStart() {
            return this.textArea ? this.textArea.getCursorStart() : null;
        },
        getCursorEnd() {
            return this.textArea ? this.textArea.getCursorEnd() : null;
        },
        setCursorStart(val) {
            if (this.textArea) this.textArea.setCursorStart(val);
        },
        setCursorEnd(val) {
            if (this.textArea) this.textArea.setCursorEnd(val);
        },
        async setFocus() {
            if (this.textArea) await this.textArea.setFocus();
        },
    },
};
</script>
